import { useEffect, useState } from 'react'
import { Typography } from '@mui/material'
import PropTypes from 'prop-types'
import ActionButton from './ActionButton'

const ToggleableButton = (props) => {
  const { icon, label, on: onProp, onChange, ...rest } = props

  const [on, setOn] = useState(onProp)
  useEffect(() => {
    setOn(onProp)
  }, [onProp])

  return (
    <ActionButton
      disableRipple={!!label}
      {...rest}
      icon={icon ? (on ? icon.on : icon.off) : undefined}
      sx={
        label
          ? {
              fontSize: '24px',
              width: '1em',
              height: '1em',
              padding: 0,
            }
          : undefined
      }
      onClick={(e) => {
        e.stopPropagation()
        setOn((on) => !on)
        onChange?.(!on)
      }}
    >
      {label ? (
        <Typography
          component="span"
          sx={{
            alignItems: 'center',
            backgroundColor: on ? 'primary.main' : 'transparent',
            borderRadius: '0.2em',
            border: (theme) => `1px solid ${theme.palette.primary.main}`,
            color: on ? 'background.default' : 'primary.main',
            display: 'inline-flex',
            fontSize: '0.5em',
            fontWeight: 600,
            justifyContent: 'center',
            width: '1.5em',
            height: '1.5em',
          }}
        >
          {label}
        </Typography>
      ) : undefined}
    </ActionButton>
  )
}

ToggleableButton.propTypes = {
  icon: function (props, propName, componentName) {
    const value = props[propName]
    if (value && props.label) {
      return new Error(
        `"${propName}" should be used without "label" in "${componentName}"`
      )
    }
    PropTypes.checkPropTypes(
      {
        [propName]: PropTypes.shape({
          on: PropTypes.node.isRequired,
          off: PropTypes.node.isRequired,
        }),
      },
      { [propName]: value },
      propName,
      componentName
    )
  },
  label: PropTypes.string,
  on: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
}

export default ToggleableButton
